import { administrationRequests } from "api/administrationApi";
import AutoPickSelectInput from "server/components/Fields/AutoPickSelectInput";
import React from "react";
import { ReferenceInput, required, SelectInput } from "react-admin";
import { CourseChoices } from "utils/choices";

const StudentEnrollmentYear = ({ handleParamChange }) => {
  return (
    <>
      <ReferenceInput
        reference={administrationRequests.getStructuralUnitsSelect()}
        source="structuralUnitId"
        filter={{ filterByUser: true }}
      >
        <AutoPickSelectInput
          source="structuralUnitId"
          label="Факултет"
          validate={required()}
          emptyText={false}
          onValueChange={v => handleParamChange("structuralUnitId", v)}
        />
      </ReferenceInput>
      <SelectInput
        source="course"
        label="Курс"
        choices={CourseChoices}
        emptyText={false}
        onChange={e => handleParamChange("course", e.target.value)}
      />
    </>
  );
};

export default StudentEnrollmentYear;
